import React, { ReactElement, ReactNode } from 'react';
import './MarkdownHelpContent.less';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type Props = {
    children: ReactElement;
    className?: string;
    mobileNav?: ReactNode;
};

const MarkdownHelpContent = ({ children, className, mobileNav }: Props) => {
    const { t } = useTranslation();

    return (
        <div className={classNames('markdown-help-content', className)}>
            <h3 className={'mt-2 mb-2'}>{t('help.global.contentTitle')}</h3>
            {mobileNav}
            <div aria-live="polite" aria-atomic="true">
                {children}
            </div>
        </div>
    );
};

export default MarkdownHelpContent;
